// System-related English translations
export const systemEn = {
  'ai.model.configuration': 'AI Model Configuration',
  'ai.model.created': 'AI model created successfully',
  'ai.model.deleted': 'AI model deleted successfully',
  'ai.model.selected': 'AI model selected successfully',
  'ai.model.updated': 'AI model updated successfully',
  'add.ai.model': 'Add AI Model',
  'confirm.delete.ai.model': 'Are you sure you want to delete this AI model?',
  'edit.ai.model': 'Edit AI Model',
  'enter.model.name': 'Enter model name (e.g., qwen3-vl:8b or gemma-3-27b-it)',
  'failed.to.create': 'Failed to create',
'failed.to.delete': 'Failed to delete',
  'failed.to.fetch.data': 'Failed to fetch data',
  'failed.to.fetch.settings': 'Failed to fetch settings',
  'failed.to.save.settings': 'Failed to save settings',
  'failed.to.update': 'Failed to update',
  'model.description': 'Description',
  'model.name': 'Model Name',
  'model.purpose': 'Model Purpose',
  'model.purpose.document.processing': 'Document Processing (Legacy)',
  'model.purpose.document.processing.image': 'Document Processing - Image',
  'model.purpose.document.processing.pdf': 'Document Processing - PDF',
  'model.purpose.document.type.detection': 'Document Type Detection',
  'model.purpose.telegram.chat': 'Telegram Chat',
    'no.ai.models.available': 'No AI models available',
    'customer': 'Customer',
    'customer.created.successfully': 'Customer Created Successfully',
    'customer.deleted.successfully': 'Customer Deleted Successfully',
    'customer.email': 'Customer Email',
    'customer.management': 'Customer Management',
    'customer.name': 'Customer Name',
    'customer.phone': 'Customer Phone',
  'save.settings': 'Save Settings',
  'select.model': 'Select',
'select.model.purpose': 'Select model purpose',
  'selected.model': 'Selected',
  'settings': 'Settings',
  'settings.saved.successfully': 'Settings saved successfully',
  'fuel.station.location': 'Fuel Station Location',
  'fuel.station.location.tooltip': 'Used to detect fuel stops for fuel efficiency calculation. Right-click the fuel station on Google Maps to get its coordinates.',
  'fuel.station.lat': 'Latitude (e.g. 10.266595)',
  'fuel.station.lon': 'Longitude (e.g. 106.359337)',
  'system.data.management': 'System Data Management',
  'system.information': 'System Information',
  'total.drivers': 'Total Drivers',
  'total.shipping.records': 'Total Shipping Records',
  'total.vehicles': 'Total Vehicles',
  
  // OSM Preprocessing translations
  'osm.preprocessing': 'OSM Data Preprocessing',
  'osm.preprocessing.status': 'Preprocessing Status',
  'osm.data.management': 'OSM Data Management',
  'osm.no.data': 'No OSM data in database',
  'osm.has.data': 'OSM data is available',
  'osm.nodes': 'Nodes',
  'osm.road.segments': 'Road Segments',
  'osm.address.points': 'Address Points',
  'osm.boundaries': 'Administrative Boundaries',
  'osm.estimated.db.size': 'Estimated Database Size',
  'osm.start.preprocessing': 'Start Preprocessing',
  'osm.clear.data': 'Clear OSM Data',
  'osm.download.data': 'Download OSM Data',
  'osm.preprocessing.in.progress': 'Preprocessing in progress... This may take 15-30 minutes.',
  'osm.preprocessing.complete': 'OSM preprocessing completed successfully',
  'osm.preprocessing.failed': 'OSM preprocessing failed',
  'osm.clear.confirm': 'Are you sure you want to clear all OSM data? This cannot be undone.',
  'osm.clear.success': 'OSM data cleared successfully',
  'osm.clear.failed': 'Failed to clear OSM data',
  'osm.download.confirm': 'Download vietnam-latest.osm.pbf file (~500MB)? This may take several minutes.',
  'osm.download.success': 'OSM data downloaded successfully',
  'osm.download.failed': 'Failed to download OSM data',
  'osm.preprocess.confirm': 'Start OSM preprocessing? This will take 15-30 minutes and requires ~4GB RAM.',
  'osm.file.path': 'OSM File Path',
  'osm.clear.existing': 'Clear Existing Data',
  'osm.statistics': 'OSM Statistics',
  'osm.benefits.title': 'Benefits of Preprocessing',
  'osm.benefits.memory': '90% less memory usage',
  'osm.benefits.startup': '95% faster startup time',
  'osm.benefits.performance': 'Better query performance',
};
